import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';
import type { Auditor360Resultado, FaseDisputa } from '@/types/agentesIa';

interface Auditor360ResultadoResponse {
  success: boolean;
  data: Auditor360Resultado | null;
}

export function useAuditor360Resultado(
  empresaId: number | undefined,
  licitacaoId: number | undefined,
  fase: FaseDisputa,
  refreshKey?: string
) {
  return useQuery<Auditor360Resultado | null>({
    queryKey: ['auditor-360-resultado', empresaId, licitacaoId, fase, refreshKey],
    queryFn: async () => {
      const response = await api.get<Auditor360ResultadoResponse>(
        `/empresas/${empresaId}/auditor-360`,
        { params: { licitacaoId, fase } }
      );
      return response.data;
    },
    enabled: Boolean(empresaId && licitacaoId),
  });
}
